var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 270,
        width: 770,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("circle", { attrs: { cx: "185", cy: "382", r: "2" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "-193",
          y: "56",
          rx: "6",
          ry: "6",
          width: "183",
          height: "20",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "20",
          rx: "2",
          ry: "2",
          width: "183",
          height: "20",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "60",
          rx: "2",
          ry: "2",
          width: "750",
          height: "200",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "45",
          rx: "2",
          ry: "2",
          width: "115",
          height: "9",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }